<div uiactionstrip>
  <btn
    class="tertiary"
    [settings]="{
      icon: ICONS.CHEVRON_LEFT,
      disabled: currentSheet() <= 0,
      tag: 'Excel Viewer Previous Sheet',
    }"
    (click)="prevSheet()"
  >
  </btn>

  <label
    class="text-size-input-label text-input-label font-medium dark:text-input-label-dark"
    [label]="sheetLabel()"
  ></label>

  <btn
    class="tertiary"
    [settings]="{
      icon: ICONS.CHEVRON_RIGHT,
      disabled: currentSheet() >= totalSheets() - 1,
      tag: 'Excel Viewer Next Sheet',
    }"
    (click)="nextSheet()"
  >
  </btn>
</div>

<div uiexcelviewercanvas [uiloading]="'Excel File'">
  @if (errorMessage(); as error) {
    <div class="p-4 text-red-600 dark:text-red-400">{{ error }}</div>
  } @else if (activeSheet(); as sheet) {
    <table>
      <tbody>
        @for (row of sheet.rows; track $index) {
          <tr>
            @for (cell of row; track $index) {
              <td>{{ cell }}</td>
            }
          </tr>
        }
      </tbody>
    </table>
  }
</div>
